import React from 'react';
import {observer} from 'mobx-react';
import {LexicalEditor, LabelHelper, DocumentAssignmentRules} from 'components';
import {AnnotatablePdfPreview} from 'components/pdf';
import {ModalButtons} from 'components/modals';
import {t} from 'shared/core';

const RichTextEditor = observer(({uiState}) => {
  const {companyDocument, employees} = uiState;

  return (
    <div>
      <LexicalEditor
        placeholder={'company_settings.documents.Add template content'}
        label={'company_settings.documents.Company Document Content'}
        onChange={content => uiState.updateContent(content)}
        mergeFields={uiState.mergeFields}
        signatures={uiState.signatureList}
        initialEditorState={companyDocument.lexicalState}
        initialHTML={companyDocument.richText}
        companyDocument={companyDocument}
        employees={employees}
        onAssigneeChanged={(assignee) => uiState.onAssigneeChanged(assignee)}
      />
      <DocumentAssignmentRules assignmentRules={companyDocument.assignmentRules}/>
      <ModalButtons onCancel={() => uiState.cancelCompanyDocumentEdit()} onSave={() => uiState.saveRichTextTemplate()}/>
    </div>
  );
});

const PDFTemplateEditor = observer(({uiState}) => {
  const {companyDocument, employees} = uiState;

  return (
    <div>
      <LabelHelper label={t('company_settings.documents.Company Document Annotations')}/>
      <AnnotatablePdfPreview
        employees={employees}
        companyDocument={companyDocument}
        pdfUrl={companyDocument.originalFile.link('url')}
        onSave={annotations => uiState.savePdfTemplate(annotations)}
        onCancel={() => uiState.goBack()}
      />
    </div>
  );
});

const CompanyDocumentEditorFactory = observer(({uiState}) => {
  const {companyDocument} = uiState;  

  switch (companyDocument.documentType) {
    case 'rich_text_template':
      return <RichTextEditor uiState={uiState}/>;
    case 'pdf_template':
      return <PDFTemplateEditor uiState={uiState}/>;
    case 'static_document':
      return <ModalButtons onCancel={() => uiState.cancelCompanyDocumentEdit()}
                           onSave={() => uiState.saveCompanyDocument()}/>;
    default:
      throw new Error(`Unsupported document type of ${companyDocument.documentType}`);
  }
});

export default CompanyDocumentEditorFactory;
